import React from 'react'
import { Field } from 'react-final-form'

import Grid from '@mui/material/Grid'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'

import Button from '../Common/Button'
import TextField from '../Common/TextField'
import Radio from '@/components/Common/Radio'

const FormContact = ({ handleSubmit, submitting, requiredtab, forceColor = 'black' }) => {

  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="mt-6" />

      <Grid container>
        <Grid item xs={12}>
          <RadioGroup row>
            <FormControlLabel
              control={
                <Field
                  name="title"
                  // @ts-ignore
                  component={Radio}
                  type="radio"
                  value="Mrs"
                  style={{ color: forceColor }}
                />
              }
              label={t({ id: 'web_madame' })}
            />
            <FormControlLabel
              control={
                <Field
                  name="title"
                  // @ts-ignore
                  component={Radio}
                  type="radio"
                  value="Mr"
                  style={{ color: forceColor }}
                />
              }
              label={t({ id: 'web_monsieur' })}
            />
          </RadioGroup>
        </Grid>

        <Grid item xs={12}>
          <Field
            name={'name'}
            fullWidth
            placeholder={t({ id: 'web_contact_votre_nom' })}
            label={t({ id: 'web_contact_votre_nom' })}
            hideLabel
            requiredtab={requiredtab}
            type={'text'}
            // @ts-ignore
            component={TextField}
          />
        </Grid>

        <Grid item xs={12}>
          <Field
            name={'pharmacie_name'}
            fullWidth
            placeholder={t({ id: 'web_company' })}
            label={t({ id: 'web_company' })}
            hideLabel
            requiredtab={requiredtab}
            type={'text'}
            // @ts-ignore
            component={TextField}
          />
        </Grid>

        <Grid item xs={12}>
          <Field
            name={'phone'}
            fullWidth
            placeholder={t({ id: 'web_contact_telephone' })}
            label={t({ id: 'web_contact_telephone' })}
            hideLabel
            type={'text'}
            requiredtab={requiredtab}
            // @ts-ignore
            component={TextField}
          />
        </Grid>
      </Grid>

      <div className="mt-6" />

      <div className="flex justify-center">
        <Button
          loading={submitting}
          type="submit"
          variant={'contained'}
          color={'primary'}
          size={'small'}
          style={{
            minWidth: 200,
          }}
        >
          Envoyer
        </Button>
      </div>
    </form>
  )
}

export default FormContact
